import SectionSubGroup from "@components/SectionGroup/SectionSubGroup"
import Localization from "@localization/Index"
import { useMobileMediaQuery } from "@utils/MediaComponents"
import { SearchResultTypeEnum } from "cs.node.utils/SearchUtils"

type Props = {
    type: SearchResultTypeEnum,
    selected: boolean
    count: number,
    onClick: () => void
}

const getSearchResultTypeTheme = (type: SearchResultTypeEnum): { label: (count:number)=>string, icon: string } => {
    switch(type) {
        case SearchResultTypeEnum.Item:
            return { label: (count) => Localization.SEARCH_BAR.ARTICOLI(count), icon: "bi-upc-scan" }
        case SearchResultTypeEnum.Order:
            return { label: (count) => Localization.SEARCH_BAR.ORDINI(count), icon: "bi-bag-check" }
        case SearchResultTypeEnum.Shop:
            return { label: (count) => Localization.SEARCH_BAR.SHOP(count), icon: "bi-shop" }
        case SearchResultTypeEnum.Customer:
            return { label: (count) => Localization.SEARCH_BAR.CLIENTI(count), icon: "bi-people" }
        default:
            return { label: (count) => "", icon: "" }
    }
}

const HeaderSearchBarResultFilter = (props: Props) =>{
    const { type, count, onClick, selected } = props
    const isMobile = useMobileMediaQuery()

    const { label, icon } = getSearchResultTypeTheme(type)

    if(isMobile) {
        return <>
        <div role="button" className={`bg-${selected ? "primary-light" : "muted"} me-4 mt-field d-flex align-items-center justify-content-center`} style={{height: 40, width: 40, border: "1px dashed var(--bs-gray-gray-500)", borderRadius: "0.75rem"}} onClick={onClick}>
            <i className={`${icon} fs-1 text-muted`} />
        </div>
        </>
    }

    return <>
        <SectionSubGroup small role="button" className={`bg-${selected ? "primary-light" : "muted"} me-4`} style={{height: 64}} onClick={onClick}>
            <span className="cs-link">
                <i className={`${icon} fs-4 text-muted me-2`} /> {label(count)}
            </span>
        </SectionSubGroup>
    </>
}

export default HeaderSearchBarResultFilter